(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header"]) return;
  try {
    

// Mega Menu
document.querySelectorAll('#desktop-menu .menu-button').forEach(button => {
  button.addEventListener('mouseover', event => {
    console.log('mouse overa');
    event.stopPropagation();
    const submenu = event.currentTarget.closest('.menu-button').querySelector('.mg-menu');
    if (submenu) {
      submenu.classList.remove('hidden');
    }
  });
});
document.querySelectorAll('#desktop-menu .menu-button').forEach(button => {
  button.addEventListener('mouseout', event => {
    event.stopPropagation();
    const submenu = event.currentTarget.closest('.menu-button').querySelector('.mg-menu');
    if (submenu) {
      submenu.classList.add('hidden');
    }
  });
});

// Mobile Menu
const hamburgerBtn = document.getElementById("hamburger-btn");
const mobileMenu = document.getElementById("mobile-menu");
const mobileClose = document.querySelector(".mobile-close");

function showMobileMenu() {
    console.log("show mobile menu");
    if (mobileMenu.classList.contains("hidden")) {
        mobileMenu.classList.remove("hidden");
        setTimeout(() => {
            mobileMenu.classList.remove("opacity-0");
            mobileMenu.classList.add("opacity-100");
        }, 50);
        document.body.classList.add("overflow-hidden");
    }
}

function hideMobileMenu() {
    setTimeout(() => {
        mobileMenu.classList.remove("opacity-100");
        mobileMenu.classList.add("opacity-0");
    }, 50);
    setTimeout(() => {
        mobileMenu.classList.add("hidden");
    }, 400);
    document.body.classList.remove("overflow-hidden");
}

hamburgerBtn.addEventListener("click", showMobileMenu);
mobileClose.addEventListener("click", hideMobileMenu);

//Mobile Menu Submenu
document.querySelectorAll('#mobile-menu .this-row').forEach(item => {
    item.addEventListener('click', event => {
        const submenu = event.currentTarget.querySelector('.submenu');
        if (submenu) {
            submenu.classList.add('-translate-x-full');
        }
    });
});

// Event listener for back buttons in submenus
document.querySelectorAll('#mobile-menu .submenu .close-button').forEach(button => {
    button.addEventListener('click', event => {
        event.stopPropagation();
        const submenu = event.currentTarget.closest('.submenu');
        if (submenu) {
            submenu.classList.remove('-translate-x-full');
        }
    });
});

// Event listener for the close button
document.querySelector('.mobile-close').addEventListener('click', () => {
    const mobileMenu = document.getElementById('mobile-menu');
    mobileMenu.classList.add('hidden');
});


// Language bar
class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('ul'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    
        this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      }
    
      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    
      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
    
        this.hidePanel();
        this.elements.button.focus();
      }
    
      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }
    
      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
      }
    
      closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) {
          this.hidePanel();
        }
      }
    }
    customElements.define('localization-form', LocalizationForm);

// //landing page play video land-01 

// const playBtn = document.getElementById('play-button');
// const video = document.getElementById('video');
// const playIcon = document.getElementById('play-icon');
// const pauseIcon = document.getElementById('pause-icon');

// playBtn.addEventListener('click', () => {
//     console.log('clicked');
//     if(video.paused){
//         video.play();
//         playIcon.classList.add('hidden');
//         pauseIcon.classList.remove('hidden');
//     } else {
//         video.pause();
//         playIcon.classList.remove('hidden');
//         pauseIcon.classList.add('hidden');
//     }
// });

//logo in the nav -  land-02
// document.addEventListener('scroll', () => {

//     const logo = document.querySelector('.logo');
//     const menu = document.querySelectorAll('.mg-menu');
//     const scrollPosition = window.scrollY;
//     if(scrollPosition > 0){
//         logo.classList.remove('lg:w-[70px]');
//         logo.classList.add('lg:w-[70px]');

        
        
//     } else {
//         logo.classList.add('lg:w-[70px]');
//         logo.classList.remove('lg:w-[70px]');
        
//     }
//     menu.forEach((item) => {
//         if(scrollPosition > 0){
//             item.classList.remove('top-[155px]');
//             item.classList.add('top-[118px]');
//         } else {
//             item.classList.add('top-[155px]');
//             item.classList.remove('top-[118px]');
//         }
//     });
// });
function setFullHeight() {
  const fullHeightElements = document.querySelectorAll('.jssize');
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;

  fullHeightElements.forEach((element) => {
    if (windowWidth < 768) {
       // console.log(windowWidth);
      element.style.height = `${windowHeight}px`;
    } else {
      element.style.height = ''; // Reset the height when the screen width is greater than or equal to 768px
    }
  });
}
// Set the height initially
setFullHeight();

// Update the height when the window is resized
window.addEventListener('resize', setFullHeight);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-promo-popup"] && !window.DesignMode) return;
  try {
    
   const popups = document.querySelectorAll(".promo-popup");
    popups.forEach((popup) => {
        const popupClose = popup.querySelector(".popup-close");
        popupClose.addEventListener("click", () => {
            popup.classList.add('hidden');
            console.log("Popup close button clicked");
        });

        const popupCloseMobile = popup.querySelector(".popup-btn");
        popupCloseMobile.addEventListener("click", () => {
            popup.classList.add('hidden');
            console.log("Mobile close button clicked");
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-video"] && !window.DesignMode) return;
  try {
    
//landing page play video land-01 

const playBtn = document.getElementById('play-button');
const video = document.getElementById('video');
const playIcon = document.getElementById('play-icon');
const pauseIcon = document.getElementById('pause-icon');
const soundBtn = document.getElementById('sound-button');
const soundon = document.getElementById('sound-on-icon');
const soundoff = document.getElementById('sound-off-icon');

playBtn.addEventListener('click', () => {
    console.log('clicked');
    if(video.paused){
        video.play();
        playIcon.classList.add('hidden');
        pauseIcon.classList.remove('hidden');
    } else {
        video.pause();
        playIcon.classList.remove('hidden');
        pauseIcon.classList.add('hidden');
    }
});
soundBtn.addEventListener('click', () => {
    console.log('clicked');
    if(video.muted){
        video.muted = false;
        soundon.classList.add('hidden');
        soundoff.classList.remove('hidden');
    } else {
        video.muted = true;
        soundon.classList.remove('hidden');
        soundoff.classList.add('hidden');
    }
});



  } catch(e) { console.error(e); }
})();
      })();
